export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/kball-profile-3939d91966a335659a52ff0808fcddca.png";